// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"715f4831","723":"0cdf638c","892":"5c1a7af4"}[chunkId] + ".chunk.js";
};